import React from 'react';
import { AuthProvider } from './context/AuthContext';
import { CountryProvider } from './context/CountryContext';
import { LeadModalProvider } from './context/LeadModalContext';
import { CustomDialogProvider } from './context/CustomDialogContext';
import LeadModal from './components/LeadModal';
import AppRoutes from './routes/AppRoutes';
import './index.css';

function App() {
  React.useEffect(() => {
    const handleContextMenu = (e) => {
      if (e.target.tagName === 'IMG') {
        e.preventDefault();
      }
    };
    const handleDragStart = (e) => {
      if (e.target.tagName === 'IMG') {
        e.preventDefault();
      }
    };

    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('dragstart', handleDragStart);

    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('dragstart', handleDragStart);
    };
  }, []);

  return (
    <AuthProvider>
      <CountryProvider>
        <CustomDialogProvider>
          <LeadModalProvider>
            <AppRoutes />
            <LeadModal />
          </LeadModalProvider>
        </CustomDialogProvider>
      </CountryProvider>
    </AuthProvider>
  );
}

export default App;

